export const ACCESS_REQUESTS_PAGE_SIZE = 20;
/**
 * The number of access requests to reasonably display before pushing
 * notifications below the fold. This is an approximation based on the average
 * height of each node and the height of the viewport, without having to fetch,
 * render and measure the entire list beforehand.
 */
export const TRUNCATED_ACCESS_REQUESTS_PAGE_SIZE = 3;
export const MOBILE_TRUNCATED_ACCESS_REQUESTS_PAGE_SIZE = 2;
